module.exports = __webpack_public_path__ + "static/media/shit.4b7a52dc.png";